export default {"src":"/_next/static/media/gear.c5b74b93.svg","height":512,"width":512};